import { CommonResponse } from "@gtpl/shared-models/sale-management";
import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { getManager, Repository } from "typeorm";
import { IndentDTO, IndentRequest } from "./dto/indent-data.request";
import { PackingIndent } from "./packing-indent.entity";
import { IndentFormAdapter } from "./indent-form.adapter";
import { ErrorResponse } from "@gtpl/shared-models/common-models";
import { IndentFormDto } from "./dto/indent-form.dto";
import appSettings from "apps/services/config";
import { PlantIdRequest } from "./dto/indent-drop-down.request";

@Injectable()
export class PackingIndentService {
    constructor(
        @InjectRepository(PackingIndent) private indentRepo: Repository<PackingIndent>,
        private indentFormAdapter :IndentFormAdapter,
        // private productAdapter: ProductAdapter,
      ) { }
      async getIndentDataByIndentNumber(req:IndentDTO):Promise<CommonResponse>{
        const indentData = await this.indentRepo.findOne({where:{indentNumber:`${req.indentNumber}`}})
        if(indentData){
            return new CommonResponse(true,1111,'data retrieved',indentData)
        }else{
            return new CommonResponse(false,1111,'No data for selected indent Number',undefined)
        }
      }

      async CreateIndentFormEntry (indentDto:IndentFormDto,isUpdate: boolean):Promise<CommonResponse>{
        try{
           
            const slNo = await this.indentRepo.count()
            const indentNum = "IND" + "/" + "00" + Number(Number(slNo) + 1)
            indentDto.indentNumber = indentNum
            const convertIndentFormEntity:PackingIndent = this.indentFormAdapter.convertDtoToEntity(indentDto)
            const savedIndentFormEntity: PackingIndent = await this.indentRepo.save(convertIndentFormEntity);
            const savedIndentFormDTO: IndentFormDto = this.indentFormAdapter.convertEntityToDto(savedIndentFormEntity);
            if (savedIndentFormDTO) {
                const response = new CommonResponse(true, isUpdate ? 11100 : 11101, isUpdate ? ' Updated Successfully' : 'Created Successfully', savedIndentFormDTO);
                return response;
            } else {
                throw new ErrorResponse(1011, 'Something went wrong');
            }
        }catch (error) {
            return error;
        }
      }
      
      async getindentbarcodedetails(): Promise<CommonResponse>{
        try{
            const manager= getManager();
            const query = 'SELECT stock_type AS stockType,sale_order_no AS sale0rderNo,po_number AS poNumber,p.sale_order_id AS saleOrderId,p.item_id AS saleOrderItemId,Round(quantity) AS quantity,item_name AS itemName,sale_order_item_id AS saleOrderItemId,indent_number AS indentNumber,unit_id,p.status,received_quantity AS receivedQuantity,issued_quantity AS issuedQuantity FROM '+appSettings.procure_db+'.packing_indent p LEFT JOIN '+appSettings.sales_db+' .sale_order s ON s.sale_order_id=p.sale_order_id LEFT JOIN '+appSettings.masters_db+'.items i ON i.item_id=p.item_id LEFT JOIN '+appSettings.sales_db+'.so_invoice_details si ON si.sale_order_id=p.sale_order_id ORDER BY s.created_at DESC';           
            const result =await manager.query(query)
            if (result) {
              return new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
            } else {
              return new CommonResponse(false, 1111, "Error occure")
        
            }
        
          }catch(err){
            return err;
          }
          
        

    }
 
    async updateReceivedQuantity(req: IndentRequest): Promise<CommonResponse> {
      const response = await this.indentRepo.update({ indentNumber: req.indentNumber}, { status: req.status,receivedQuantity: req.receivedQuantity });
      if (response) {
          return new CommonResponse(true, 11107, 'Status and receivedquantity updated successfully');
      } else {
          throw new ErrorResponse(11106, ' Error in update of OT Status ');
      }
  }
  async getReceivedQuantityagainstPonumber(req:IndentDTO): Promise<CommonResponse>{
    try{
        const manager= getManager();
        const query = 'SELECT  SUM(ROUND(sc.issued_quantity)) AS IndentQuantity FROM `store_consumption` sc LEFT JOIN `packing_indent` p ON sc.sale_order_id=p.sale_order_id WHERE indent_number = "'+req.indentNumber+'"';           
        const result =await manager.query(query)
        if (result) {
          return new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
        } else {
          return new CommonResponse(false, 1111, "Error occure")
    
        }
    
      }catch(err){
        return err;
      }


}
async updateIssuedQuantity(req: IndentRequest): Promise<CommonResponse> {
  const response = await this.indentRepo.update({ indentNumber: req.indentNumber}, { status: req.status,issuedQuantity: req.issuedQuantity });
  if (response) {
      return new CommonResponse(true, 11107, 'Status and issuedQuantity updated successfully');
  } else {
      throw new ErrorResponse(11106, ' Error in update of OT Status ');
  }
}

  async getIndentDropDownData(req: PlantIdRequest):Promise<CommonResponse>{
    const manager = getManager();
    const indentsDataQry = `select indent_form_id as indentId,unit_id as unitId,indent_number as indentNumber from packing_indent where unit_id = ${req.unitcodeId} and status = 'OPEN'`;
    const indentsdata = await manager.query(indentsDataQry)
    if(indentsdata.length > 0){
      return new CommonResponse(true,8888,'data rereived',indentsdata)
    }else{
      return new CommonResponse(false,1111,'No data')
    }
  }
}